import { useEffect } from 'react'
import { Layout, Row, Col, Modal } from 'antd'
import { LogoMain } from 'wvrio-styleguide'
import party from 'party-js'

export default WelcomeMessage = ({ visible, setVisible }) ->

  useEffect( ->
    if visible
      element = document.querySelector('.welcome-message')
      party.element(element, {
        count: 250
      })
    undefined
  , [])

  <Modal
    className="welcome-message"
    width='40vw'
    closable={false}
    footer={false}
    centered={true}
    onCancel={ ->
      localStorage.setItem('newUser', false)
      setVisible(false)
    }
    visible={visible}
  >
    <Layout style={{ height: '20vh', }}>
      <Row style={{ flex: 'auto' }} justify="center" type="flex" align="middle">
        <Col style={{ textAlign: "center" }}>
          <LogoMain style={{ width: 380, marginLeft: '19%', marginRight: '19%' }}/>
        </Col>
      </Row>
      <Row style={{ flex: 'auto' }} justify="center" type="flex" align="middle">
        <Col style={{ textAlign: "center" }}>
          <h1>Hey {_.startCase(Weaver.getInstance().currentUser()?.username)},</h1>
          <h2>Welcome to wvr.io</h2>
        </Col>
      </Row>
    </Layout>
  </Modal>
